import { Box, Checkbox, FormControlLabel, FormHelperText } from '@mui/material';
import { forwardRef } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import {
  AdvancedFieldWrapperVertical as FieldWrapperVertical,
  ReadOnly,
  useEntityPermission,
  useFormPermissions,
  useLocalization,
} from '@ui-framework/index';
import { FormattedMessage } from 'react-intl';
import { getWeekdays } from '@product-framework/index';

const RecurrenceWeeklyOptions = forwardRef((props, ref) => {
  const { formatMessage } = useLocalization();
  const { control, errors, getValues } = useFormContext();
  const { isReadOnly } = useEntityPermission();
  const { permissions } = useFormPermissions();
  const currentRecurrenceWeekdays = getValues('recurrenceWeekdays');
  const formatList = items =>
    items.length < 2
      ? items.join('')
      : `${items.slice(0, -1).join(', ')}${items.length > 2 ? ',' : ''} and ${items.at(-1)}`;

  if (isReadOnly(permissions?.recurrenceWeekdays, currentRecurrenceWeekdays)) {
    return (
      <ReadOnly>
        <FormattedMessage
          id="EVERY_WEEK_ON_WEEK"
          defaultMessage="Every Week On {week}"
          values={{
            week: formatList(currentRecurrenceWeekdays.map(rw => rw.label)),
          }}
        />
      </ReadOnly>
    );
  }

  const WEEKDAYS_LONG = getWeekdays(formatMessage).map(wk => ({
    label: wk.longLabel,
    value: wk.value,
  }));

  return (
    <FieldWrapperVertical
      field={{
        name: 'recurrenceWeekdays',
        label: {
          localeId: 'EVERY_WEEK_ON',
          defaultMessage: 'Every Week On',
        },
        required: true,
      }}
      errors={errors}>
      <Box ref={ref}>
        <Controller
          control={control}
          name="recurrenceWeekdays"
          render={({ field, fieldState: { error } }) => {
            const currentValue = field.value || [];
            const selectedWeekdays = currentValue.map(x => x.value);
            return (
              <Box>
                {WEEKDAYS_LONG.map(item => {
                  return (
                    <FormControlLabel
                      key={item.label}
                      control={
                        <Checkbox
                          {...field}
                          size="small"
                          checked={selectedWeekdays.includes(item.value)}
                          onChange={e => {
                            if (e.target.checked) {
                              field.onChange([
                                ...currentValue,
                                { value: item.value },
                              ]);
                            } else {
                              field.onChange(
                                currentValue.filter(
                                  x => x.value !== item.value,
                                ),
                              );
                            }
                          }}
                        />
                      }
                      label={item.label}
                    />
                  );
                })}
                {error?.message && (
                  <Box>
                    <FormHelperText error={Boolean(error?.message)}>
                      {error?.message}
                    </FormHelperText>
                  </Box>
                )}
              </Box>
            );
          }}
        />
      </Box>
    </FieldWrapperVertical>
  );
});

export default RecurrenceWeeklyOptions;
